import React from 'react';

const PremiumPaywall = () => (
  <div className="paywall">
    <div className="paywall__gradient" />
    <div id="premiumPaywallContainer" />
  </div>
);

export default PremiumPaywall;
